import React, { useState, useEffect } from 'react'
import { TimelineItem } from '../shared/TimelineItem'
import { QuestEnum, TimelineItem as TimelineItemType } from '@/types'
import { useGameplayContext } from '@/contexts/gameplayContext'
import { getStory } from '@/constants/story'

interface StoryModalProps {
  onClose: () => void
}

export const StoryModal: React.FC<StoryModalProps> = ({ onClose }) => {
  const { gameData, addTimelineItem, findNextStoryItem } = useGameplayContext()
  const [nextStoryItem, setNextStoryItem] = useState<TimelineItemType | null>(findNextStoryItem())

  useEffect(() => {
    setNextStoryItem(findNextStoryItem())
  }, [gameData.timeline, gameData.completedQuests])

  if (!nextStoryItem) {
    return null
  }

  const isQuestIncomplete =
    nextStoryItem.type === 'quest' &&
    !gameData.completedQuests.includes(getStory()[nextStoryItem.contentRef as number].value as QuestEnum)

  const handleAction = () => {
    if (isQuestIncomplete) {
      // If it's an incomplete quest, just close the modal
      onClose()
    } else {
      // Add current item to timeline
      addTimelineItem(nextStoryItem)

      // Find next item
      const nextItem = findNextStoryItem()

      if (nextItem) {
        // If there's a next item, show it
        setNextStoryItem(nextItem)
      } else {
        // If no more items, close the modal
        onClose()
      }
    }
  }
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <TimelineItem item={nextStoryItem} gameSkills={gameData.skills} showTime={false} />
        <div className="flex justify-end mt-4">
          <button
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded-lg text-lg transition-colors"
            onClick={handleAction}
          >
            {isQuestIncomplete ? 'Close' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  )
}
